import axios from 'axios';
import { constructServiceURL } from '../../../../../utils/URLTools';

export const apiFetchMrdSettingsList = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getMrdSettingsListDefault',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      physicalMrd: true,
    },
  });
  return axios.get(serviceURL, payload);
};

export const apiEditMrdSettings = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'updateMrdSettingsDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.put(serviceURL, { updateMrdSettingsRowCommandList: payload });
};
